/*
 * Copyright (C) 2022 Do inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Emanuele (ebalo) Balsamo <emanuele.balsamo@do-inc.co>
 */

export enum ContractTypes {
	marketplace = "marketplace",
	masterchef = "masterchef",
	melodity = "melodity",
	melodityGovernance = "melodityGovernance",
	stacking = "mtacking",
	stackingPanda = "mtackingPanda",
	stackingReceipt = "mtackingReceipt",
	melodityIco = "melodityIco",
}